import { render, staticRenderFns } from "./SA.vue?vue&type=template&id=2898a96b&scoped=true"
import script from "./SA.vue?vue&type=script&lang=js"
export * from "./SA.vue?vue&type=script&lang=js"
import style0 from "./SA.vue?vue&type=style&index=0&id=2898a96b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2898a96b",
  null
  
)

export default component.exports